module.exports = __webpack_public_path__ + "static/media/wasabi_header_logo_dark.efd84ff0.png";